import { render, staticRenderFns } from "./HoverMenu.vue?vue&type=template&id=6e5f331c&scoped=true&"
import script from "./HoverMenu.vue?vue&type=script&lang=js&"
export * from "./HoverMenu.vue?vue&type=script&lang=js&"
import style0 from "./HoverMenu.vue?vue&type=style&index=0&id=6e5f331c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f331c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VMenu})
